import { render } from "./NoTax.vue?vue&type=template&id=d51a3380&scoped=true"
import script from "./NoTax.vue?vue&type=script&lang=js"
export * from "./NoTax.vue?vue&type=script&lang=js"

import "./NoTax.vue?vue&type=style&index=0&id=d51a3380&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d51a3380"]])

export default __exports__